import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../../appTheme";


export const addEditOptionStyle = StyleSheet.create({
    parent: {
        flex: 1,
        backgroundColor: '#F8FAFC'
    },
    subParent: {
        flex: 1,
        padding: 16
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'flex-end',
        marginTop: 8,
        marginHorizontal: 15
    },
    topContent: {
        backgroundColor: appColors.light,
        marginTop: 10,
        borderRadius: 14,
        paddingHorizontal: 16,
        paddingVertical: 14,
        borderWidth: 1,
        borderColor: '#E2E8F0',
        width: '100%'
    },
    bottomContent: {
        backgroundColor: appColors.light,
        paddingVertical: 14,
        paddingHorizontal: 16,
        marginTop: 14,
        borderRadius: 14,
        borderWidth: 1,
        borderColor: '#E2E8F0',
        width: '100%'
    },
    saveTxt: {
        color: appColors.light,
        fontFamily: appFonts.bold,
        textTransform: 'capitalize'
    },
    canceltxt: {
        fontFamily: appFonts.bold,
        color: appColors.dark,
        textTransform: 'capitalize'
    },
    nameCon: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: 10
    },
    colorCon: {
        justifyContent: 'space-between',
        backgroundColor: '#F8FAFC',
        paddingVertical: 10,
        paddingHorizontal: 14,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: '#E2E8F0',
        marginTop: 12
    },
    inpTxt: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.medium,
        color: '#1E293B'
    },
    inpCon: {
        borderColor: '#CBD5E1',
        borderWidth: 1,
        borderRadius: 8,
        height: 44,
        backgroundColor: '#FFFFFF'
    },
    inpErr: {
        marginLeft: 4,
        marginTop: 4,
        color: '#EF4444',
        fontFamily: appFonts.medium,
        fontSize: fontSize.errorFontSize
    },
    checkBoxCon: {
        flexDirection: 'row',
        marginTop: 4
    },
    buttonCon: {
        alignSelf: 'flex-end',
        marginTop: 10,
        paddingHorizontal: 10
    },
    bottomConChild: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignSelf: 'flex-end'
    },
    bottomContent2: {
        marginTop: 14,
        flexDirection: 'row',
        flexWrap: 'wrap',
        flex: 1
    },
    middleContentWrap: {
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row'
    },
    middleContentWrap2: {
        flex: 1,
        width: '100%'
    },
    inpLabel: {
        paddingHorizontal: 4,
        textTransform: 'capitalize',
        paddingBottom: 6,
        fontSize: fontSize.smallerFontSize,
        color: '#475569',
        fontFamily: appFonts.bold
    },
    popBg: {
        flex: 1,
        backgroundColor: appColors.transparentBackground
    },
    colorBg: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#F8FAFC',
        borderRadius: 12,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#E2E8F0'
    },

    // Modern additions
    card: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        padding: 16,
        borderWidth: 1,
        borderColor: '#E2E8F0',
        marginBottom: 12,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.04,
        shadowRadius: 3,
        elevation: 1
    },
    cardHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 12
    },
    cardHeaderLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10
    },
    cardIconCircle: {
        width: 34,
        height: 34,
        borderRadius: 17,
        backgroundColor: '#EAF6F8',
        justifyContent: 'center',
        alignItems: 'center'
    },
    cardTitle: {
        fontSize: 15,
        fontFamily: appFonts.bold,
        color: '#1E293B'
    },
    cardSubtitle: {
        fontSize: 12,
        fontFamily: appFonts.medium,
        color: '#64748B',
        marginTop: 2
    },
    countBadge: {
        backgroundColor: '#F1F5F9',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#CBD5E1',
        marginLeft: 8
    },
    countBadgeText: {
        fontSize: 12,
        fontFamily: appFonts.medium,
        color: '#475569'
    },
    actionButtonsRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8
    },
    valueItemCard: {
        backgroundColor: '#F8FAFC',
        borderRadius: 8,
        padding: 8,
        borderWidth: 1,
        borderColor: '#E2E8F0',
        marginBottom: 0
    },
    indexBadge: {
        width: 26,
        height: 26,
        borderRadius: 13,
        backgroundColor: '#E2E8F0',
        justifyContent: 'center',
        alignItems: 'center'
    },
    indexText: {
        fontSize: 11,
        fontFamily: appFonts.bold,
        color: '#475569'
    },
    colorSwatchBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        borderColor: '#CBD5E1',
        borderRadius: 6,
        paddingHorizontal: 8,
        height: 38,
        gap: 6
    },
    colorSwatchPreview: {
        width: 18,
        height: 18,
        borderRadius: 9,
        borderWidth: 1.5,
        borderColor: '#94A3B8'
    },
    colorSwatchHex: {
        fontSize: 11,
        fontFamily: appFonts.bold,
        color: '#334155'
    },
    deleteBtn: {
        width: 38,
        height: 38,
        borderRadius: 6,
        backgroundColor: '#FEE2E2',
        justifyContent: 'center',
        alignItems: 'center'
    }
})